import React from 'react';
import { Row } from 'react-bootstrap';
import { Selectize, Fieldset } from '~/components/FormControl';
import PropTypes from 'prop-types';
import { maxLimit } from '../BoonForm';

function DVandPoint({ negOptions, posOptions }) {
    return (
        <Fieldset
            className={'px-4'}
            fieldsetStyle={{ flexGrow: 1 }}
        >
            <Fieldset.Legend>Dv & Point:</Fieldset.Legend>
            <Row>
                <Selectize
                    name="addonDvList"
                    sm={3}
                    options={[...negOptions, ...posOptions]}
                    isNegativeAllowed
                    maxLimit={maxLimit}
                />
                <Selectize
                    name="minDvList"
                    sm={3}
                    options={posOptions}
                    maxLimit={maxLimit}
                />
                <Selectize
                    name="maxDvList"
                    sm={3}
                    options={posOptions}
                    maxLimit={maxLimit}
                />
                <Selectize
                    name="addonPointList"
                    sm={3}
                    options={posOptions}
                    maxLimit={maxLimit}
                />
            </Row>
        </Fieldset>
    );
}

DVandPoint.propTypes = {
    negOptions: PropTypes.array.isRequired,
    posOptions: PropTypes.array.isRequired,
};

export default DVandPoint;
